export default __webpack_public_path__ + "static/mbm-power-shake-a0b8de7ecf08afb2f3390d521d993100.png";